import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button, {
  ButtonTypes,
  ButtonDefaultType,
} from '../Button';

import ConditionalRendering from '../ConditionalRendering';
import Spinner from '../Spinner';
import Spacing from '../Spacing';

export const ActionSizes = ['base', 'small', 'xsmall', 'large'];
export const ActionDefaultSize = 'base';

const defaultProps = {
  type: ButtonDefaultType,
  block: false,
  size: ActionDefaultSize,
  className: '',
  disabled: false,
  loading: false,
  isLight: false,
  onClick: () => { },
  children: null,
};

const propTypes = {
  type: PropTypes.oneOf(ButtonTypes),
  block: PropTypes.bool,
  size: PropTypes.oneOf(ActionSizes),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  isLight: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

const Action = ({
  type,
  block,
  size,
  className,
  disabled,
  loading,
  isLight,
  onClick,
  children,
}) => (
  <Button
    type={type}
    onClick={onClick}
    className={classnames(
      // common classes
      'inline-flex items-center justify-center rounded font-medium text-center',
      'focus:outline-none',

      // size-related classes
      size === 'base' && 'px-4 py-2',
      size === 'small' && 'px-3 py-2',
      size === 'xsmall' && 'px-2 py-1',
      size === 'large' && 'px-6 py-4',

      // block styles
      block && 'flex w-full text',
      !block && 'inline-flex',

      // disabled-related styles
      disabled && 'opacity-50 pointer-events-none',
      !disabled && 'shadow',

      className,
    )}
  >
    <ConditionalRendering on={loading}>
      <Spacing right={4}>
        <Spinner size={20} light={isLight} />
      </Spacing>
    </ConditionalRendering>
    {children}
  </Button>
);

Action.defaultProps = defaultProps;
Action.propTypes = propTypes;

export default Action;
